import { Col, Page, Row, Text, useStoreUIV2 } from '@gimlite/ui-v2';
import { observer } from 'mobx-react-lite';
import { Module } from '../../../components/module/module.component';

export const ProductDigitalPage = observer(() => {
  const { SSOStore } = useStoreUIV2();

  return (
    <Page>
      <Col justifyContent="flex-start" alignItems="flex-start" gap={32}>
        <Col justifyContent="flex-start" alignItems="flex-start">
          <Text variant="title-1" color="deep_indigo">
            Modules de gestion centralisée du stationnement
          </Text>
          <Text variant="title-3">Choisissez un module pour commencer</Text>
        </Col>
        <Row
          width="max-content"
          flexWrap="wrap"
          justifyContent="flex-start"
          alignItems="flex-start"
          gap={16}
        >
          {(SSOStore.resources?.modules || []).length >= 1 ? (
            [...(SSOStore.resources?.modules || [])]
              .sort((a, b) => {
                return a.label.localeCompare(b.label);
              })
              .map(
                ({
                  name,
                  description,
                  canUse,
                  label,
                  title,
                  color,
                  url,
                  logo,
                }) => (
                  <Module
                    key={name}
                    config={{ isActive: canUse }}
                    data={{
                      label,
                      description,
                      color,
                      title,
                      url,
                      logo,
                    }}
                  ></Module>
                ),
              )
              .sort((a, b) => {
                if (a === b) return 0;
                return a ? 1 : -1;
              })
          ) : (
            <Text variant="label">Aucun service ici</Text>
          )}
        </Row>
      </Col>
    </Page>
  );
});
